import { Flex } from '@chakra-ui/react';

interface ISummaryBoxProps {
  children?: React.ReactNode;
}

export const SummaryBox: React.FC<ISummaryBoxProps> = ({ children }): JSX.Element => {
  return (
    <Flex border="1px" borderColor="gray.200" direction="column" gap={8} mb={20} p={8} w="full">
      {children}
    </Flex>
  );
};
